<template>
  <div class="page-content" style="min-height: 100vh;">
    <!-- Main content -->
    <div class="content-wrapper">
      <!-- Content area -->
      <div class="content d-flex justify-content-center align-items-center">
        <!-- Login card -->
        <form class="login-form" action="index.html">
          <div class="card mb-0">
            <div class="card-body">
              <div class="text-center mb-3">
                <img
                  src="assets/images/tikkerLogo.png"
                  class="mb-2"
                  style="max-width: 100%; border-radius: 3px;"
                />
                <h5 class="mb-0">Login to your account</h5>
                <span class="d-block text-muted">Your credentials</span>
              </div>
              <div
                class="form-group form-group-feedback form-group-feedback-left"
              >
                <input
                  v-model="username"
                  type="text"
                  class="form-control"
                  placeholder="Username"
                  v-on:focusout="isValid($event, username, 'user')"
                />
                <div class="form-control-feedback">
                  <i class="icon-user text-muted"></i>
                </div>
              </div>
              <div
                class="form-group form-group-feedback form-group-feedback-left"
              >
                <input
                  v-model="password"
                  type="password"
                  class="form-control"
                  placeholder="Password"
                  v-on:focusout="isValid($event, password, 'pass')"
                />
                <div class="form-control-feedback">
                  <i class="icon-lock2 text-muted"></i>
                </div>
                <div
                  class="form-group text-center text-muted"
                  style="margin-top:5%;"
                >
                  <span v-if="!formValid" style="font-weight:bold;">{{
                    formMessage
                  }}</span>
                </div>
              </div>
              <div class="form-group">
                <button
                  type="button"
                  class="btn btn-primary btn-block"
                  style="background-color: #ad466c;"
                  v-on:click="signIn"
                >
                  Sign in <i class="icon-circle-right2 ml-2"></i>
                </button>
              </div>
              <div class="text-center">
                <span class="navbar-text">
                  Tikker version 1.5.2.1
                </span>
              </div>
            </div>
          </div>
        </form>
        <!-- /login card -->
      </div>
      <!-- /content area -->
    </div>
    <!-- /main content -->
  </div>
</template>

<script>
import { auth, db } from '../assets/js/firebase/db.js';
// import { QuerySelector } from 'ag-grid-community';
import LogRocket from 'logrocket';

export default {
  name: 'authComp',
  data() {
    return {
      username: null,
      password: null,
      formValid: true,
      formMessage: null
    };
  },
  methods: {
    isValid: function(e, value) {
      if (value == null) {
        this.formValid = false;
        this.formMessage = 'Inputs cannot be blank.';
      } else if (value.trim() == '') {
        this.formValid = false;
        this.formMessage = 'Inputs cannot be blank.';
      }
    },
    signIn: function() {
      auth
        .signInWithEmailAndPassword(this.username, this.password)
        .then(async () => {
          //Get the name and type from the db after login.
          db.collection('users')
            .doc(auth.currentUser.uid)
            .get()
            .then(doc => {
              if (doc.exists) {
                try {
                  //check the database to ensure that the user have permissions to access the portal.
                  if (doc.data().roles[0] == 'admin') {
                    this.$store.commit('updateAuth', {
                      value: true,
                      company: doc.data().company
                    });
                    LogRocket.identify(auth.currentUser.uid, {
                      name: doc.data().name,
                      email: doc.data().email,
                      // Add your own custom user variables here, ie:
                      // subscriptionType: 'pro'
                    });
                  } else {
                    this.formValid = false;
                    this.formMessage = 'Access denied.';
                  }

                } catch (err) {
                  if (doc.data().roles == undefined) {
                    this.formValid = false;
                    this.formMessage = 'Access denied.';
                  } else {
                    this.formValid = false;
                    this.formMessage =
                      'There was an unexpected error logging in';
                  }
                }
              } else {
                console.log('doc doesnt exist');
                this.formValid = false;
                this.formMessage = 'There was an unexpected error logging in';
              }
            });
        })
        .catch(() => {
          this.formValid = false;
          this.formMessage = 'Incorrect username or password.';
        });
    }
  }
};
</script>
